import React from 'react'
import styled from 'styled-components'
import { Flex, NotificationDot } from 'pancakeswap-uikit'
import { useExpertModeManager } from 'state/user/hooks'
import GlobalSettings from 'components/Menu/GlobalSettings'
import Transactions from '../../../components/App/Transactions'

const AppHeaderContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background: white;
`

const Header = () => {
  const [expertMode] = useExpertModeManager()

  return (
    <AppHeaderContainer>
      <Transactions />
      <NotificationDot show={expertMode}>
        <GlobalSettings />
      </NotificationDot>
    </AppHeaderContainer>
  )
}

export default Header
